/**
 * Aggressive auth cleanup — clears ALL auth-related storage.
 * Called on both login (before new session) and logout.
 */

const AUTH_STORAGE_KEYS = [
  'auth_intended_role',
  'practitioner_filters',
  'sb-tgnzqtzbydztcfhqmxxh-auth-token',   // Supabase session key
] as const;

const AUTH_SESSION_KEYS = [
  'session_active_role',
  'resonow_preferred_portal',
] as const;

const AUTH_COOKIES = [
  'password_reset_type',
] as const;

/** Remove a cookie by name on .resonow.org */
function clearCookie(name: string) {
  try {
    document.cookie = `${name}=; domain=.resonow.org; path=/; max-age=0`;
    document.cookie = `${name}=; path=/; max-age=0`;
  } catch { /* ignore */ }
}

/**
 * Wipe every auth-related artifact from the browser.
 * Safe to call multiple times.
 */
export function clearAllAuthState() {
  // localStorage
  for (const key of AUTH_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }

  // sessionStorage
  for (const key of AUTH_SESSION_KEYS) {
    sessionStorage.removeItem(key);
  }

  // Cookies
  for (const name of AUTH_COOKIES) {
    clearCookie(name);
  }

  console.log('[auth-cleanup] All auth state cleared');
}
